export const REACT_APP_GOOGLE_CLIENT_ID = '242142020465-4bv6t1p4r7vveij5ncucmu21lbu31rni.apps.googleusercontent.com';
